export default [
  {
    path: '/items-class',
    component: () => import('./views/Index'),
    name: 'items-class',
    redirect: { name: 'items-class-list' },
    children: [
      {
        path: '/items-class',
        name: 'items-class-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: '/items-class/detail/:item_id',
        name: 'items-class-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
